<!--
 * @Description  : 经停站信息卡片
-->

<template minapp="mpx" xlang="wxml">
  <view class="es-station-stay-card" wx:if="{{stationList.length}}">
    <view class="es-station-stay-card__item">
      <view class="es-station-stay-card__item-title other" wx:for="{{stationTitle}}" wx:key="index">
        {{item}}
     </view>
    </view>
     <view wx:for="{{stationList}}" wx:key="index">
       <view  class="es-station-stay-card__item current" wx:if="{{stayInfo != null ? item.station_name===stayInfo.from_station_name || item.station_name===stayInfo.to_station_name : false}}"> 
         <view class="es-station-stay-card__item-title current">
            <view class="es-station-stay-card__item-number current">  {{index + 1}} </view>
          </view>
         <view class="es-station-stay-card__item-title current" >{{item.station_name}}</view>
         <view class="es-station-stay-card__item-title current">{{item.arrive_time}}</view>
         <view class="es-station-stay-card__item-title current">{{item.start_time}}</view>
         <view class="es-station-stay-card__item-title current">{{item.stopover_time}}</view>
       </view>
       <view  class="es-station-stay-card__item other" wx:else>
          <view class="es-station-stay-card__item-title other">
            <view class="es-station-stay-card__item-number other">  {{index + 1}} </view>
          </view>
          <view class="es-station-stay-card__item-title other" >{{item.station_name}}</view>
          <view class="es-station-stay-card__item-title other">{{item.arrive_time}}</view>
          <view class="es-station-stay-card__item-title other">{{item.start_time}}</view>
          <view class="es-station-stay-card__item-title other">{{item.stopover_time}}</view>
       </view>
        
    </view>
  </view>
  <blank-page
    wx:else
    blank-page-style="blank-page-style"
    blankImageUrl="{{blankImageUrl}}"
    blankContextTitle="{{blankContextTitle}}"
    blankContextSubTitle="{{blankContextSubTitle}}"
    hasButton="{{hasButton}}"
    blankPageType="blank-page"
    bind:click-button="clickButton"
  />
  
</template>


<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { queryTrainInfo } from '@/api/train/index'
  import { formatDate } from '@/utils/baseDate'
  import store from '@/store'
  import { LOAD_FAIL_CONTENT } from '@/common/constant'

  createComponent({
    data: {
      stationTitle: ['站序', '站名', '到时', '发时', '停留'],
      stationList: [],
      blankImageUrl: null,
      blankContextTitle: '',
      blankContextSubTitle: '',
      hasButton: false
    },
    props: {
      stayInfo: Object
    },
    computed: {},
    methods: {
      fetchTrainInfo() {
        queryTrainInfo({
          train_date: this.stayInfo?.train_date,
          train_no: this.stayInfo?.train_no,
          train_code: this.stayInfo?.train_code,
          from_station_name: this.stayInfo?.from_station_name,
          to_station_name: this.stayInfo?.to_station_name,
          fromStationName: this.stayInfo?.from_station_name,
          toStationName: this.stayInfo?.to_station_name
        })
          .then(res => {
            const { data, success, code, message } = res || {}
            if (success) {
              if (code === '0') {
                const { train_station_info } = data === null ? [] : data
                const list = train_station_info
                this.stationList = list
                this.blankImageUrl = ''
                this.blankContextTitle = ''
                this.blankContextSubTitle = ''
                this.hasButton = false
              } else {
                this.blankImageUrl = '' // 空数据
                this.blankContextTitle = '未找到时刻表'
                this.blankContextSubTitle = '请重试'
                this.hasButton = true
                mpx.showToast({
                  title: message, //提示的内容,
                  icon: 'error' //图标,
                })
              }
            } else {
              this.blankImageUrl = ''
              this.blankContextTitle = '加载失败'
              this.blankContextSubTitle = LOAD_FAIL_CONTENT
              this.hasButton = true
              mpx.showToast({
                title: LOAD_FAIL_CONTENT, //提示的内容,
                icon: 'error' //图标,
              })
            }
          })
          .finally(() => {
            mpx.hideLoading()
          })
      },
      clickButton() {
        this.fetchTrainInfo()
      }
    },
    watch: {
      stayInfo: {
        immediate: true,
        handler() {
          console.log('this.stayInfo?.train_code', this.stayInfo)
          if (this.stayInfo?.train_code) {
            this.fetchTrainInfo()
          }
        }
      }
    }
  })
</script>

<style scoped lang="stylus" src="./style.styl"></style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'blank-page': '@/es-mpx-ui/lib/blank-page'
    }
  }
</script>

